/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import FilterItem from './FilterItem';
import { FilterSelectItem } from './FilterSelect';
import { ResourceFilter } from '../table/types';

export interface FilterItemProps {
  menu: FilterSelectItem;
  filters: ResourceFilter[];
  onSelect: (filter: FilterSelectItem) => void;
}
const FilterList = (props: FilterItemProps) => {
  const { menu, filters, onSelect } = props;
  if (!isNil(filters)) {
    return (
      <>
        {filters.map(({ key, value }) => {
          const filter = get(menu, ['children', key, 'children', value]);
          if (filter) {
            return <FilterItem key={filter.key} filter={filter} onClick={() => onSelect(filter)} />;
          }
          return <></>;
        })}
      </>
    );
  } else {
    return <></>;
  }
};

export default FilterList;
